import React from 'react';

import { Modal, Button } from 'react-bootstrap';

const headerByType = {
  Request: 'Assistance-seeking country',
  Provided: 'Assistance-providing country',
  Received: 'Assistance-receiving country'
};

const subtitleByType = {
  Request: 'Assistance need',
  Provided: 'Assistance provided',
  Received: 'Assistance received'
};

const blockquoteHeaderByType = {
  Request: 'needs',
  Provided: 'provided',
  Received: 'received'
};

class TagTableModal extends React.Component {
  renderHeader() {
    const content = this.props.content;

    return (
      <Modal.Title>
        <h3>
          <small>{ headerByType[content.flag] }:</small><br></br>
          { content.countryName }
        </h3>
        <h4>
          <small>{ subtitleByType[content.flag] }:</small><br></br>
          { content.fullTagName }
        </h4>
      </Modal.Title>
    );
  }

  renderBlockQuote(content) {
    let blockquote;

    if (content.description) {
      let className = `blockquote blockquote-quoted assistance-table-modal__blockquote
        assistance-table-modal__blockquote--${content.flag}`;

      blockquote = (
        <span>
          <h4>
            <small>Description of { blockquoteHeaderByType[content.flag] }: </small>
          </h4>
          <blockquote className={ className }>
            <p className="mb-0">
              { content.description || "No description provided" }
            </p>
          </blockquote>
        </span>
      );
    } else {
      blockquote = (
        <span>
          <h4>
            <small>
              Description of { blockquoteHeaderByType[content.flag] }:
              <span>No description provided.</span>
            </small>
          </h4>
        </span>
      );
    }

    return blockquote;
  }

  renderBody() {
    const { content } = this.props;

    const source = content.reportSourceYear
      ? (
        <span>
          National report submitted in <strong>{ content.reportSourceYear }</strong>
        </span>
      )
      : 'Unknown';

    const sourceLink = content.reportSourceLink
      ? <a href={ content.reportSourceLink } target="_blank">View national report</a>
      : null;

    return (
      <Modal.Body>
        <h4>
          <small>Source: { source }</small>&nbsp;
          <small>{ sourceLink }</small>
        </h4>
        { this.renderBlockQuote(content) }
        <p>
          { content.hasProposal
            ? (
              <p>
                <strong>A project proposal has been developed.</strong> &nbsp;
                <a target="_blank" rel="noopener noreferrer"
                  href="https://www.un.org/disarmament/project-proposals/"
                >
                  View project proposal
                </a>
              </p>
            )
            : <span>No project proposal has been developed yet. </span>
          }
        </p>
      </Modal.Body>
    );
  }

  render() {
    const { show, onHide } = this.props;

    return (
      <Modal
        show={ show }
        onHide={ onHide }
        className="assistance-table-modal"
      >
        <Modal.Header closeButton>
          { this.renderHeader() }
        </Modal.Header>

        { this.renderBody() }

        <Modal.Footer>
          <Button onClick={ onHide }>
            <small>Close</small>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default TagTableModal;



// WEBPACK FOOTER //
// ./src/components/AssistanceLanding/Tagtable-modal.js